import { createAsyncThunk } from "@reduxjs/toolkit";
import { post } from "../../api/api";
import { IChangePassword, IForgotPasswordLink, ILoginRequest, IResetPassword } from "../../models/loginRequest";

//Call login api request
export const postLoginUser = createAsyncThunk("user/postLoginUser", async (loginRequest: ILoginRequest) => {
    try {
        const response = await post("/login", loginRequest)
        return response.data;
    } catch (error) {
        console.log(error)
    }
});

//Call login api request
export const refreshLoginUser = createAsyncThunk("user/refresh", async () => {
    try {
        const response = await post("/refresh")
        return response.data;
    } catch (error) {
        console.log(error)
    }
});

//Call login api request
export const logoutUser = createAsyncThunk("user/logout", async () => {
    try {
        const response = await post("/logout")
        return response.data;
    } catch (error) {
        console.log(error)
    }
});

//Call send forgot password link request
export const sendForgotPasswordLink = createAsyncThunk("user/resetPasswordLink", async (forgotPasswordLink: IForgotPasswordLink) => {
    try {
        const response = await post("/password/email", forgotPasswordLink)
        return response.data;
    } catch (error) {
        console.log(error)
    }
});

//Call reset password api request
export const resetPassword = createAsyncThunk("/password/reset", async (resetPassword: IResetPassword) => {
    try {
        const response = await post("/password/reset", resetPassword)
        return response.data;
    } catch (error) {
        console.log(error)
    }
});

//Call change password api request
export const changePassword = createAsyncThunk("user/changePassword", async (changePassword: IChangePassword) => {
    try {
        const response = await post("/user/password", changePassword)
        return response.data;
    } catch (error) {
        console.log(error)
    }
});